import PropTypes from 'prop-types';

// One partner's own email and phone for the patient, as api/patient/transform shapes it.
const partnerContactPropType = PropTypes.shape({
  partnerId: PropTypes.string.isRequired,
  partnerName: PropTypes.string.isRequired,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  hasPlaceholderEmail: PropTypes.bool,
});

export default partnerContactPropType;
